// Ignore module for browserify (see package.json)


//////////////////
// WEBPACK FOOTER
// ./~/jsonld/browser/ignore.js
// module id = 121
// module chunks = 3